import type { StoreLow } from "@/types/api";
import { formatWithKRW, getLocaleString } from "@/lib/format";
import { useLang } from "@/i18n/LangContext";

interface HistoricLowCardProps {
  storeLow: StoreLow;
}

export default function HistoricLowCard({ storeLow }: HistoricLowCardProps) {
  const { lang, t } = useLang();

  return (
    <div className="bg-card-bg dark:bg-card-bg rounded-2xl border border-gray-200 dark:border-card-border shadow-sm p-6 mb-6">
      <div className="flex items-center gap-2.5 mb-4">
        <div className="w-8 h-8 rounded-lg bg-gray-900 dark:bg-card-border flex items-center justify-center">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
          </svg>
        </div>
        <h2 className="text-lg font-bold text-gray-900 dark:text-white">{t.gameDetail.historicLow}</h2>
      </div>
      <div className="bg-emerald-50 dark:bg-emerald-500/10 rounded-xl border border-emerald-200 dark:border-emerald-500/30 p-4 flex items-center justify-between">
        <div>
          <p className="text-sm text-emerald-700 dark:text-emerald-300 font-medium mb-1">
            <span className="font-bold">{storeLow.shop.name}</span>{t.gameDetail.recordedAt}
            {storeLow.timestamp && (
              <span className="text-emerald-500 dark:text-emerald-400 ml-1.5 text-xs font-normal">
                ({new Date(storeLow.timestamp).toLocaleDateString(getLocaleString(lang))})
              </span>
            )}
          </p>
          <p className="text-2xl font-black text-emerald-700 dark:text-emerald-300 tabular-nums">
            {formatWithKRW(storeLow.price.amount, storeLow.price.currency, lang)}
          </p>
        </div>
        {storeLow.cut > 0 && (
          <span className="bg-emerald-500 text-white text-lg font-bold px-3 py-1.5 rounded-lg">
            -{storeLow.cut}%
          </span>
        )}
      </div>
      <p className="text-xs text-gray-400 dark:text-muted mt-2 text-right">
        via IsThereAnyDeal
      </p>
    </div>
  );
}
